import DOMPurify from "dompurify";
import { useState } from "react";
import tempImg from "../../../../assets/tempIMG1.jpg";

export default function useGetInitialData() {
  const [pageData, setPagedata] = useState(-1);
  // const [categories, setCategories] = useState(-1);
  const [galleries, setGalleries] = useState(-1);
  const [references, setReferences] = useState(-1);

  const url = `https://hogast.hr/wp`;

  // GETING PAGES
  const getInitialData = async (lang) => {
    try {
      const response = await fetch(
        `${url}/wp-json/custom/v1/init-data?lang=${lang}`,
        {
          mode: "cors",
        }
      );

      if (response.ok) {
        const value = await response.json();
        sortPageData(value.pages, lang);
        setGalleries(value.galleries);
        setReferences(value.references);
      } else {
        sortPageData(false, lang);
        window.location.reload();
      }
    } catch (err) {
      sortPageData(false, lang);
      window.location.reload();
      console.log("Unexpected loading Error");
    }
  };

  // CREATING DICTIONARY
  const sortPageData = (data, lang) => {
    const tempPageData =
      //hr
      {
        home: {
          title: lang === "hr" ? "Naslovna" : "Heim",
        },
        partners: lang === "hr" ? { title: "partneri" } : { title: "partner" },
        categories: {
          nav_title: lang === "hr" ? "katalozi" : "kataloge",
          title: lang === "hr" ? "Katalog proizvoda" : "Produktkatalog",
          no_img:
            lang === "hr"
              ? "Ova kategorija trenutno nema slika."
              : "In dieser Kategorie sind derzeit keine Bilder vorhanden.",
        },
        market: {
          to: data
            ? DOMPurify.sanitize(
                data[data.findIndex((item) => item.post_name === "tomarket")]
                  .post_content
              )
            : lang === "hr"
            ? "pogledajte naš oglasnik"
            : "schauen sie sich unseren anzeigenmarkt an",
          to_title:
            lang === "hr"
              ? "pogledajte naš oglasnik"
              : "schauen sie sich unseren anzeigenmarkt an",
          to_button: lang === "hr" ? "oglasnik" : "Anzeigenmarkt",
          title: lang === "hr" ? "oglasnik" : "Anzeigenmarkt",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim  veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea  commodo consequat.",
          what_is_button:
            lang === "hr" ? "Što je oglasnik?" : "Was ist eine Anzeigenmarkt?",
          what_is_title:
            lang === "hr" ? "Što je oglasnik?" : "Was ist eine Anzeigenmarkt?",
          what_is_description:
            lang === "hr"
              ? "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim  veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea  commodo consequat."
              : "Was ist eine Anzeigenmarkt?",
          filter_button:
            lang === "hr" ? "Filtriraj kategorije" : "Kategorien filtern",
          list_count_1: lang === "hr" ? "proizvod" : "produkt",
          list_count: lang === "hr" ? "proizvoda" : "produkte",
          error_no_items:
            lang === "hr"
              ? "Trenutno nema proizvoda za ovu kategoriju."
              : "Derzeit gibt es keine Produkte in dieser Kategorie.",
          error_req:
            lang === "hr"
              ? "Pogreška! Pokušajte ponovo učitati stranicu."
              : "Fehler! Versuchen Sie die Seite erneut zu laden.",
          cart: {
            title: lang === "hr" ? "Košarica" : "Wagen",
            empty:
              lang === "hr" ? "Košarica je prazna." : "Einkaufswagen ist leer.",
            buy: lang === "hr" ? "Pošalji upit" : "Anfrage senden",
          },
        },
        about_us: {
          title: data
            ? DOMPurify.sanitize(
                data[data.findIndex((item) => item.post_name === "aboutus")]
                  .post_title
              )
            : lang === "hr"
            ? "o nama"
            : "über uns",
          info: data
            ? DOMPurify.sanitize(
                data[data.findIndex((item) => item.post_name === "aboutus")]
                  .post_content
              )
            : lang === "hr"
            ? "nema podataka"
            : "no data",
          image: data
            ? data[data.findIndex((item) => item.post_name === "aboutus")]
                .featured_image_url
            : tempImg,
        },
        references: {
          reference_button:
            lang === "hr" ? "Naše reference" : "Unsere referenzen",
          title: lang === "hr" ? "Reference" : "referenzen",
        },
        contact: {
          send_error:
            lang === "hr"
              ? "Fehler beim Senden. Versuchen Sie es später noch einmal"
              : "kontaktiere uns",
          send_success:
            lang === "hr"
              ? "Zahtjev uspješno poslan!"
              : "Anfrage erfolgreich gesendet",
          title: "kontakt",
          contact_title:
            lang === "hr" ? "Kontaktirajte nas" : "kontaktiere uns",
          cart_contact_title:
            lang === "hr"
              ? "Ispunite potrebne informacije"
              : "Informationen ausfüllen",
          button: "KONTAKT",
          send_button: lang === "hr" ? "pošalji" : "senden",
          copy: lang === "hr" ? "kopirano" : "kopiert",
          name: lang === "hr" ? "Ime" : "Name",
          surname: lang === "hr" ? "Prezime" : "Nachname",
          email: "email",
          subject: lang === "hr" ? "Naslov" : "Thema",
          message: lang === "hr" ? "Poruka" : "Nachricht",
          phone: lang === "hr" ? "broj telefona" : "Telefonnummer",
          r1: lang === "hr" ? "Račun za tvrtke" : "Firmenrechnung",
          company_name: lang === "hr" ? "Naziv tvrtke" : "Name der Firma",
          company_id: lang === "hr" ? "OIB" : "OIB",
          address: lang === "hr" ? "Adrersa" : "Adresse",
          city: lang === "hr" ? "Mjesto" : "Stadt",
          zip: lang === "hr" ? "Poštanski broj" : "Postleitzahl",
          country: lang === "hr" ? "Država" : "Staat",
          additional_info:
            lang === "hr" ? "Dodatne informacije" : "zusätzliche Information",
        },
      };
    setPagedata(tempPageData);
  };

  return { pageData, references, galleries, getInitialData };
}
